export const validEmail = new RegExp(
  "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$"
);
export const validatePhone = new RegExp(`^(0047|\\+47|47)?\\d{8}`);
export const validName = new RegExp(`^[a-zA-Z]+`);
export const validPassword = new RegExp("^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$");
